// const ProcessChartData = (rawDataObject) => {
//     console.log('now processing chart data...  ', rawDataObject);

//     const processPhysicalProgress = (inputData) => {
//         console.log("charts data: ",inputData);
//         const plannedPhysicalProgress = Number(inputData[0]?.planned_physical_progress);
       
//         const physicalProgress = [
//             { category: inputData[0].package_name, type: 'Actual Progress (%)', value: inputData[0]?.actual_physical_progress || 0},
//             { category: inputData[0].package_name, type: 'Planned Progress (%)', value: plannedPhysicalProgress || 0},
//         ];
//         return physicalProgress;     
//     };
    
//     const processFinancialProgress = (inputData) => {
//         const financialProgress = [
//             { category: inputData[0].package_name, type: 'Actual Progress (%)', value: inputData[0]?.actual_financial_progress || 0},
//             { category: inputData[0].package_name, type: 'Planned Progress (%)', value: inputData[0]?.planned_financial_progress || 0},
//         ];
//         return financialProgress;     
//     };

//     const allChartsData = { 
//        physicalProgress: processPhysicalProgress(rawDataObject), 
//        financialProgress: processFinancialProgress(rawDataObject)
//     }

//     return allChartsData;
// }

// export default ProcessChartData;









const ProcessChartData = (rawDataObject) => {
    console.log('Now processing chart data... ', rawDataObject);
  
    const castProgressToNumber = (progressValue) => {
      return Number(progressValue) || 0;
    };
  
    const processPhysicalProgress = (inputData) => {
      console.log("Charts data: ", inputData);
  
      const physicalProgress = inputData.map(data => ({
        category: data.package_name,
        type: 'Actual Progress (%)',
        value: castProgressToNumber(data.actual_physical_progress),
      })).concat(
        inputData.map(data => ({
          category: data.package_name,
          type: 'Planned Progress (%)',
          value: castProgressToNumber(data.planned_physical_progress),
        }))
      )
      .concat(
        inputData.map(data => ({
          category: data.package_name,
          type: 'Time Elapsed (%)',
          value: castProgressToNumber(data.time_elapsed_percent),
        }))
      );
      console.log('Progress LGA ######!!!!! ', physicalProgress)
      return physicalProgress;     
    };
  
    const processFinancialProgress = (inputData) => {
      const financialProgress = inputData.map(data => ({
        category: data.package_name,
        type: 'Actual Financial Progress (%)',
        value: castProgressToNumber(data.actual_financial_progress_percent),
      }))
      .concat(
        inputData.map(data => ({
          category: data.package_name,
          type: 'Time Elapsed (%)',
          value: castProgressToNumber(data.time_elapsed_percent),
        }))
      )
      .concat(
        inputData.map(data => ({
          category: data.package_name,
          type: 'Planned Financial Progress (%)',
          value: castProgressToNumber(data.planned_financial_progress_percent),
        }))
      );
  
      return financialProgress;     
    };
  
    const allChartsData = { 
      physicalProgress: processPhysicalProgress(rawDataObject), 
      financialProgress: processFinancialProgress(rawDataObject)
    };
  
    return allChartsData;
  };
  
  export default ProcessChartData;
  